import { type ProductOnboardingStep } from 'interfaces/entities/product-onboarding';
import { createAction, type ActionsUnion } from 'store/helper';

export enum OnboardingActionNames {
  SET_SELECTED_STEP = 'FEATURES/ONBOARDING/SET_SELECTED_STEP',
  ADD_DISPLAYED_STEP = 'FEATURES/ONBOARDING/ADD_DISPLAYED_STEP',
  SET_CHECKLIST_OPEN = 'FEATURES/ONBOARDING/SET_CHECKLIST_OPEN',
}

export const OnboardingActions = {
  setSelectedOnboardingStep: (step: ProductOnboardingStep | null) =>
    createAction(OnboardingActionNames.SET_SELECTED_STEP, step),
  addDisplayedStep: (step: ProductOnboardingStep) => createAction(OnboardingActionNames.ADD_DISPLAYED_STEP, step),
  setChecklistOpen: (isOpen: boolean) => createAction(OnboardingActionNames.SET_CHECKLIST_OPEN, isOpen),
};

export type OnboardingAction = ActionsUnion<typeof OnboardingActions>;
